import React from "react";

const OrganizationList = ({
  organizations,
  setSelectedOrganization,
  setActiveView,
  deleteOrganization,
}) => {
  const handleEdit = (org) => {
    setSelectedOrganization(org);
    setActiveView("add-organization");
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this organization?")) {
      deleteOrganization(id);
    }
  };

  return (
    <div className="organizations-view">
      <div className="list-header">
        <h2>
          <span>🏢</span> Organizations
        </h2>
        <button
          className="add-btn"
          onClick={() => {
            setSelectedOrganization(null);
            setActiveView("add-organization");
          }}
        >
          <span>➕</span> Add new organization
        </button>
      </div>

      {organizations.length > 0 ? (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Address</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Registration date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {organizations.map((org) => (
                <tr key={org.id}>
                  <td>{org.id}</td>
                  <td>{org.name}</td>
                  <td>{org.address}</td>
                  <td>{org.phone}</td>
                  <td>{org.email}</td>
                  <td>{org.registrationDate}</td>
                  <td className="action-cell">
                    <button
                      className="icon-btn edit-btn"
                      onClick={() => handleEdit(org)}
                      title="Edit"
                    >
                      ✏️
                    </button>
                    <button
                      className="icon-btn delete-btn"
                      onClick={() => handleDelete(org.id)}
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-message">
          <p>No organizations yet. Add the first organization.</p>
          <button
            className="add-btn"
            style={{ marginTop: "1rem" }}
            onClick={() => setActiveView("add-organization")}
          >
            <span>➕</span> Add organization
          </button>
        </div>
      )}
    </div>
  );
};

export default OrganizationList;
